import { gql } from '@api/gql';

export const GET_PRACTITIONER_PRESCRIPTIONS = gql(/* GraphQL */`
  query GetPractitionerLocationPrescriptions($searchBy: SearchByArgs, $options: QueryOptionsInputType) {
    getPractitioner(searchBy: $searchBy, options: $options) {
      practitioner_id
      contextual_affiliation {
        location_id
        prescriptions {
          ...MedicationUsageCoreFragmentAlt
          medication {
            __typename
            medication_id
            brand_name
            dose_form
          }
          usage_id
          expired
          notes
          dosage_instruction
          status
        }
      }
    }
  }
`);

export const GET_PRACTITIONER = gql(/* GraphQL */`
  query GetPractitioner($searchBy: SearchByArgs, $options: QueryOptionsInputType) {
    getPractitioner(searchBy: $searchBy, options: $options) {
      ...PractitionerCoreFragment
      contacts {
        ...ContactPointCoreFragment
      }
      qualifications {
        ...PractitionerQualificationCoreFragment
      }
      demographics {
        ...DemographicsCoreFragmentAlt
      }
      taxonomies {
        ...TaxonomiesCoreFragment
      }
      identity {
        __typename
        cynergy_id
        email
        phone
        status
        account_activated
      }
      contextual_affiliation {
        __typename
        affiliation_id
        location_id
        role
        employee_assignment {
          __typename
          assignment_id
          title
          status
        }
      }
    }
  }
`);

export const GET_PRACTITIONER_DEMOGRAPHICS = gql(/* GraphQL */`
  query GetPractitionerDemographics($searchBy: SearchByArgs, $options: QueryOptionsInputType) {
    getPractitioner(searchBy: $searchBy, options: $options) {
      ...PractitionerCoreFragment
      demographics {
        ...DemographicsCoreFragmentAlt
      }
      identity {
        __typename
        cynergy_id
        email
        phone
      }
    }
  }
`);

export const GET_PAGINATED_PRACTITIONERS = gql(/* GraphQL */`
  query GetPaginatedPractitioners($searchBy: SearchByArgs, $pagination: PaginationArgs, $sort: SortingArgs, $options: QueryOptionsInputType) {
    getPaginatedPractitioners(searchBy: $searchBy, pagination: $pagination, sort: $sort, options: $options) {
      count
      totalPages
      currentPage
      rows {
        ...PractitionerCoreFragment
        contacts {
          ...ContactPointCoreFragment
        }
        qualifications {
          ...PractitionerQualificationCoreFragment
        }
        demographics {
          ...DemographicsCoreFragmentAlt
        }
        contextual_affiliation {
          __typename
          affiliation_id
          location_id
          role
          created_at
          employee_assignment {
            __typename
            assignment_id
            title
            status
          }
        }
      }
    }
  }
`);
export const DOWNLOAD_CSV_PRACTITIONERS_REPORT = gql(/* GraphQL */`
  query DownloadCSVPractitionersReport($searchBy: SearchByArgs, $pagination: PaginationArgs, $sort: SortingArgs, $options: QueryOptionsInputType) {
    downloadCSVPractitionersReport(searchBy: $searchBy, pagination: $pagination, sort: $sort, options: $options) { url }
  }
`);

export const GET_PAGINATED_EMPLOYEE_ASSIGNMENTS = gql(/* GraphQL */`
  query GetPaginatedEmployeeAssignments(
    $searchBy: SearchByArgs
    $pagination: PaginationArgs
    $options: QueryOptionsInputType
    $sort: SortingArgs
  ) {
    getPaginatedStaffAssignments(
      searchBy: $searchBy
      pagination: $pagination
      options: $options
      sort: $sort
    ) {
      count
      currentPage
      totalPages
      rows {
        ...PractitionerAssignmentCoreFragment
        employee {
          __typename
          staff_id
          created_at
          user {
            ...UserCoreFragmentAlt
            account {
              account_id
            }
            identity {
              ...CynergyAccountCoreFragmentAlt
            }
            demographics {
              ...DemographicsCoreFragmentAlt
            }
          }
        }
      }
    }
  }
`);

export const NPI_LOOKUP = gql(/* GraphQL */`
  query NpiLookup($search: [NpiRegistrySearchTerm!]!, $pagination: PaginationArgs) {
    npiLookup(search: $search, pagination: $pagination) {
      __typename
      npi
      registration_date
      type
      demographics {
        first_name
        last_name
        credential
        sole_proprietor
        status
        prefix
        suffix
      }
    }
  }
`);

export const NPI_EXISTS = gql(/* GraphQL */`
  query NpiExists($search: [NpiRegistrySearchTerm!]!, $pagination: PaginationArgs) {
    npiLookup(search: $search, pagination: $pagination) {
      __typename
      npi
      type
      taxonomies {
        primary
        description
      }
      demographics {
        first_name
        last_name
      }

    }
  }
`);

export const PRACTITIONERS_FEED = gql(/* GraphQL */`
  query PractitionersFeed($searchBy: SearchByArgs, $pagination: PaginationArgs, $sort: SortingArgs, $options: QueryOptionsInputType) {
    practitionersFeed(searchBy: $searchBy, pagination: $pagination, sort: $sort, options: $options) {
      count
      totalPages
      currentPage
      rows {
        ...PractitionerCoreFragment
        contacts {
          ...ContactPointCoreFragment
        }
        qualifications {
          ...PractitionerQualificationCoreFragment
        }
        demographics {
          ...DemographicsCoreFragmentAlt
        }
      }
    }
  }
`);

export const GET_PAGINATED_PRACTITIONER_PRESCRIPTIONS = gql(/* GraphQL */`
  query GetPaginatedPractitionerPrescriptions($searchBy: SearchByArgs, $pagination: PaginationArgs, $sort: SortingArgs, $options: QueryOptionsInputType) {
    getPaginatedPractitioners(searchBy: $searchBy, pagination: $pagination, sort: $sort, options: $options) {
      count
      totalPages
      currentPage
      rows {
        practitioner_id
        contextual_affiliation {
          location_id
          prescriptions {
            ...MedicationUsageCoreFragmentAlt
            medication {
              __typename
              medication_id
              brand_name
              dose_form
            }
            usage_id
            expired
            notes
            dosage_instruction
            status
          }
        }
      }
    }
  }
`);

export const GET_PRACTITIONER_SIGNATURE = gql(/* GraphQL */`
  query GetPractitionerSignature($searchBy: SearchByArgs, $options: QueryOptionsInputType) {
    getPractitionerSignature(searchBy: $searchBy, options: $options) {
      ...PractitionerSignatureCoreFragment
      who {
        __typename
        practitioner_id
        npi
        prefix
        suffix
        demographics {
          __typename
          cynergy_id
          full_name
        }
      }
    }
  }
`);
